export default class DocumentViewModel {
    public document: File | undefined = undefined;
    public documentType: number | undefined = undefined;
    public documentTypeText: string | undefined = undefined;
}